import AllCampaignsPage from "@/pages/companyDashboard/AllCampaignsPage";
import {createFileRoute} from "@tanstack/react-router";
import {z} from "zod";

export const Route = createFileRoute("/_authenticated/_company/company/$companyId/campaigns/$status")({
  component: AllCampaignsPage,
  params: {
    parse: ({companyId, status}) => ({
      companyId: Number(companyId),
      status: z.enum(["active", "complete", "paused", "planned", "open"]).parse(status),
    }),
    stringify: ({companyId, status}) => ({
      companyId: String(companyId),
      status,
    }),
  },
});
